import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { clearLocalStorageExceptLastLoginService } from 'src/app/core/services/clearLocalStorageExceptLastLogin.service';
import { injectConfigs } from '../../../core/config/utils';

@Component({
  selector: 'app-force-logout',
  templateUrl: './force-logout.component.html',
  styleUrls: ['./force-logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForceLogoutComponent {
  _auth = inject(AuthService);
  router = inject(Router);
  idUrl = injectConfigs().endPoints.ID_URL;
  clearLocalStorageExceptLastLoginService = inject(
    clearLocalStorageExceptLastLoginService
  );
  logout() {
    // localStorage.clear();
    this.clearLocalStorageExceptLastLoginService.clearLocalStorageExceptLastLogin();

    window.location.pathname = '/login';
  }
}
